import type { RouteRecordRaw } from 'vue-router';

// The glob belongs to this screen: only its bundle is loaded before checkout renders.
const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

/** Both checkout views share this URL; the exact query `?type=b` chooses view B. */
export const frontDeskCheckoutRoutes = {
  name: 'front-desk-checkout',
  path: 'front-desk/checkout/:orderId',
  component: () => import('./FrontDeskCheckout.vue'),
  meta: { i18n, titleKey: 'frontDeskCheckout.metaTitle' },
} satisfies RouteRecordRaw;
